import { useEffect, useState } from "react";
import { getGstMode, GstMode, setGstMode } from "./gstSettings";

export const useGstMode = () => {
    const [gstMode, setMode] = useState(getGstMode());
    useEffect(() => {
        const handler = () => {
            setMode(getGstMode())
        }
        window.addEventListener('gst-mode-changed', handler);
        return () => window.removeEventListener('gst-mode-changed', handler)
    }, [])

    const updateGstMode = (mode: GstMode) => {
        setGstMode(mode);
       
    };

    return{
        gstMode,
        gstEnabled: gstMode === 'GST',
        setGstMode: updateGstMode
    }
}